import React, {Component} from 'react';
import {Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap';
import "./index.css";
import assets from "../../../../../util/assets";
import {PublishListItem} from "../../../../clipstore/broadcaster/library/publish-list-item";
import {Field, formValueSelector, reduxForm} from "redux-form";
import {connect} from "react-redux";
import * as actions from "../../../../../actions";
import {required} from "../../../../../util/utility";
import formEl from "../../../../../util/form";
import {clipstoreContentPriceList, clipstorePayPerMinutePriceList} from "../../../../../util/broadcaster/profile_util";
import api from "../../../../../util/clipstore/broadcaster/library";

class SetPricingModal extends Component {

    constructor() {
        super();

        this.state = {
            content: {},
            content_type: "paid",
            entire_content_price: "true",
            pay_per_minute_price: "false",
            include_in_subscription: "false",
            contentPriceOptionTemplate: clipstoreContentPriceList().map((v) => (
                <option key={v} value={v}>
                    {`£ ${v}`}
                </option>
            )),
            perMinutePriceOptionTemplate: clipstorePayPerMinutePriceList().map((v) => (
                <option key={v} value={v}>
                    {`£ ${v}`}
                </option>
            )),
        }

        this.onSubmit = this.onSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    componentDidMount() {

    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps.add_edit_pricing_content && nextProps.add_edit_pricing_content.payload !== this.props.add_edit_pricing_content.payload) {
            const payload = nextProps.add_edit_pricing_content.payload;

            this.setState({
                content: nextProps.add_edit_pricing_content.payload,
                content_type: payload.pricing.type,
                include_in_subscription: payload.pricing.part_of_subscription === "yes" ? "true" : "false",
                pay_per_minute_price: payload.pricing.ppm === 0 ? "false" : "true",
                add_to_gallery: this.props.content.gallery !== null ? "true" : "false"
            }, () => {
                if (payload.pricing.ppm !== 0) {
                    let pay_per_minute_price_value = document.getElementsByName("pay_per_minute_price_value");
                    if (pay_per_minute_price_value[0]) {
                        pay_per_minute_price_value[0].value = parseInt(payload.pricing.ppm / 100)
                    }
                }

                let entire_content_price_value = document.getElementsByName("entire_content_price_value");
                if (entire_content_price_value[0]) {
                    entire_content_price_value[0].value = parseInt(payload.pricing.price / 100)
                }

                let add_to_gallery_value = document.getElementsByName("add_to_gallery_value");
                if (add_to_gallery_value[0] && this.state.add_to_gallery === "true" && this.props.content.gallery !==null) {
                    setTimeout(()=>{
                        add_to_gallery_value[0].value = this.props.content.gallery.id
                    },1000);
                }

            })
        }

        //handle the API response for add/edit pricing
        api.handleAPIResponse(nextProps, "add_edit_pricing", () => {
            //reset the payload value as we have captured the event
            this.props.resetAddEditPricing();
        }, () => {
            this.props.toggle("refresh");
        }, () => {
            //nothing to handle
            this.props.toggle("cancel");
        })
    }

    onSubmit(values) {

        const formData = new FormData();
        formData.append("id", this.props.content.id);
        formData.append("price_for", "video");
        formData.append("type", values.content_type);

        if(values.content_type !== "free"){
            formData.append("price", api.formatPriceForAPI(document.getElementsByName("entire_content_price_value")[0].value));
            if (document.getElementsByName("pay_per_minute_price")[0].value === "true") {
                formData.append("ppm", api.formatPriceForAPI(document.getElementsByName("pay_per_minute_price_value")[0].value));
            }
        }

        if (values.content_type === "free") {
            formData.append("part_of_subscription", "yes");
        } else {
            formData.append("part_of_subscription", document.getElementsByName("include_in_subscription")[0].value === "true" ? "yes" : "no")
        }

        if (document.getElementsByName("add_to_gallery")[0].value === "true") {
            formData.append("clipstore_gallery_id", document.getElementsByName("add_to_gallery_value")[0].value);
        }
        formData.append("device[platform]", this.props.device.platform);
        formData.append("device[name]", this.props.device.name);
        formData.append("device[version]", this.props.device.version);
        formData.append("device[ip]", this.props.device.ip);
        formData.append("device[id]", this.props.device.id);
        formData.append("device[app_version]", this.props.device.app_version);
        formData.append("device[device_token]", this.props.device.device_token);


        api.addEditPricingAPI(this.props, formData);
    }

    handleChange = (event, newValue, previousValue, name) => {

        this.props.dispatch(this.props.change(name, newValue));
        let obj = {};
        obj[name] = "" + newValue;

        this.setState(obj);
    }

    getGallery = () => {
        return this.props.gallery.map((v) => (
            <option key={v.id} value={v.id}>
                {`${v.title}`}
            </option>
        ))
    }

    onCancel() {
        this.props.history.push("/broadcaster/my-library")
    }

    render() {
        const {handleSubmit} = this.props;
        return (
            <Modal isOpen={this.props.isOpen}
                   className="upload-file-modal-container">
                <ModalHeader className="border-0" id="upload-file-modal">
                <span className="text-center mb-2 upload-file-modal-container-title">
                    {
                        this.props.content &&
                        this.props.content.hasOwnProperty("pricing") &&
                        this.props.content.pricing.hasOwnProperty("type") &&
                        this.props.content.pricing.type === "free" ? "Set Pricing" : "Edit Pricing"
                    }
                </span>
                    <img src={assets.broadcast.cross}
                         alt={"cross icon"}
                         onClick={() => {
                             this.props.toggle();
                         }}/>

                </ModalHeader>
                <ModalBody className="justify-content-center">
                    {
                        this.props.content &&
                        <PublishListItem
                            isPricing={true}
                            key={this.props.content.id}
                            index={1}
                            content={this.props.content}
                        />
                    }

                    {
                        <div style={{marginTop: 16}}>
                            <form className="no-margin form-width-100"
                                  onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                <dt className="label-14">Content Type</dt>
                                <dd>
                                    <label className="broadcastType">
                                        <Field
                                            label="Free"
                                            name="content_type"
                                            type="radio"
                                            value="free"
                                            checked={this.state.content_type === "free"}
                                            validate={[required]}
                                            component={formEl.renderRadioField}
                                            onChange={this.handleChange}
                                        />
                                    </label>
                                    <label className="broadcastType">
                                        <Field
                                            label="Paid"
                                            name="content_type"
                                            type="radio"
                                            value="paid"
                                            checked={this.state.content_type === "paid"}
                                            validate={[required]}
                                            component={formEl.renderRadioField}
                                            onChange={this.handleChange}
                                        />
                                    </label>
                                </dd>

                                <dt className="by-selecting-paid-op">By selecting paid option, you can able to set price
                                    for
                                    your Content only for unsubscribed users & free for subscribed users.
                                </dt>

                                {
                                    this.state.content_type === "paid" &&
                                    <div>
                                        <Row>
                                            <Col md="6">
                                                {/*Entire Content Price*/}
                                                <label className="broadcastType">
                                                    <Field
                                                        label="Entire Content Price"
                                                        name="entire_content_price"
                                                        type="checkbox"
                                                        value="free"
                                                        validate={[required]}
                                                        checked={true}
                                                        disabled={true}
                                                        component={formEl.renderCheckBoxField}
                                                        onChange={this.handleChange}
                                                    />
                                                </label>
                                                {/*Entire Content Price*/}

                                                {/*Entire Content Price*/}
                                                <Row>
                                                    <Col md="7">
                                                        <Field
                                                            className="custom-select"
                                                            name="entire_content_price_value"
                                                            component="select">
                                                            {this.state.contentPriceOptionTemplate}
                                                        </Field>
                                                    </Col>
                                                    <Col md="5" className="no-margin no-padding">
                                                        <div style={{marginTop: 6}}>video</div>
                                                    </Col>
                                                </Row>
                                                {/*Entire Content Price*/}
                                            </Col>

                                            <Col md="6">
                                                {/*Pay Per Minute Price*/}
                                                <label className="broadcastType">
                                                    <Field
                                                        label="Pay Per Minute Price"
                                                        name="pay_per_minute_price"
                                                        type="checkbox"
                                                        checked={this.state.pay_per_minute_price === "true"}
                                                        component={formEl.renderCheckBoxField}
                                                        onChange={this.handleChange}
                                                    />
                                                </label>
                                                {/*Pay Per Minute Price*/}

                                                {/*Pay Per Minute Price*/}
                                                {
                                                    this.state.pay_per_minute_price === "true" && <Row>
                                                        <Col md="7">
                                                            <Field
                                                                className="custom-select"
                                                                name="pay_per_minute_price_value"
                                                                component="select">
                                                                {this.state.perMinutePriceOptionTemplate}
                                                            </Field>
                                                        </Col>
                                                        <Col md="5" className="no-margin no-padding">
                                                            <div style={{marginTop: 6}}>min</div>
                                                        </Col>
                                                    </Row>
                                                }
                                                {/*Pay Per Minute Price*/}
                                            </Col>
                                        </Row>

                                        {/*Include in subscription*/}
                                        <Row style={{marginTop: 16}}>
                                            <Col md="12">
                                                <label className="broadcastType">
                                                    <Field
                                                        label="Include in subscription"
                                                        name="include_in_subscription"
                                                        type="checkbox"
                                                        checked={this.state.include_in_subscription === "true"}
                                                        component={formEl.renderCheckBoxField}
                                                        onChange={this.handleChange}
                                                    />
                                                    <div className="include-in-subscription">
                                                        By selecting this option, the content you are uploading will be
                                                        free for
                                                        subscribed users
                                                    </div>
                                                </label>
                                            </Col>
                                        </Row>
                                        {/*Include in subscription*/}
                                    </div>
                                }

                                {/*Add to gallery*/}
                                <Row style={{marginTop: 16}}>
                                    <Col md="12">
                                        <label className="broadcastType">
                                            <Field
                                                label="Add to gallery"
                                                name="add_to_gallery"
                                                type="checkbox"
                                                checked={this.state.add_to_gallery === "true"}
                                                component={formEl.renderCheckBoxField}
                                                onChange={this.handleChange}
                                            />

                                        </label>
                                    </Col>
                                </Row>
                                {/*Add to gallery*/}

                                {/*Add to gallery options*/}
                                {
                                    this.props.gallery !== null && this.state.add_to_gallery === "true" &&
                                    <Row>
                                        <Col md="12">
                                            <label className="broadcastType">
                                                <Field
                                                    className="custom-select"
                                                    name="add_to_gallery_value"
                                                    component="select"
                                                    value={this.props.content.gallery !== null && this.props.content.gallery.id}>
                                                    {this.getGallery()}
                                                </Field>
                                            </label>
                                        </Col>
                                    </Row>
                                }
                                {/*Add to gallery options*/}

                                <Row className="display-flex-vertical-center no-margin button-container">
                                    <Col md="3" className="no-padding"/>
                                    <Col md="3" className="no-padding">
                                        <Button color="outline-secondary" onClick={()=>{
                                            this.props.toggle();
                                        }}>
                                            CANCEL
                                        </Button>
                                    </Col>
                                    <Col md="3" className="no-padding">
                                        <Button color="primary" >
                                            {
                                                this.props.add_edit_pricing.isFetching
                                                    ?
                                                    <img
                                                        src={assets.loading_white}
                                                        alt={"Loading"}
                                                        width={26}
                                                        height={26}
                                                    />
                                                    :
                                                    "SAVE"
                                            }

                                        </Button>
                                    </Col>
                                    <Col md="3" className="no-padding"/>
                                </Row>
                            </form>
                        </div>
                    }
                </ModalBody>
                <ModalFooter className="border-0 justify-content-center">

                </ModalFooter>
            </Modal>
        );
    }
}

function mapStateToProps(state) {

    const selector = formValueSelector("SetPricingModalForm");
    const payload = state.clipstore_broadcaster_add_edit_pricing_content.payload;
    const init = {
        content_type: payload && payload.pricing.type,
        entire_content_price: true,
        include_in_subscription: payload && payload.pricing.part_of_subscription === "yes" ? "true" : "false",
        pay_per_minute_price: payload && payload.pricing.ppm === 0 ? "false" : "true",
    };

    return {
        initialValues: init,
        device: state.device.payload,
        content_type: "free",
        // entire_content_price: selector(state, "entire_content_price"),
        // pay_per_minute_price: selector(state, "pay_per_minute_price"),
        publish_videos: state.clipstore_broadcaster_publish_videos,
        add_edit_pricing: state.clipstore_broadcaster_add_edit_pricing,
        add_edit_pricing_content: state.clipstore_broadcaster_add_edit_pricing_content
    }
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
SetPricingModal = reduxForm({
    form: "SetPricingModalForm", // a unique identifier for this form
    enableReinitialize: true,
})(SetPricingModal);

// You have to connect() to any reducers that you wish to connect to yourself
SetPricingModal = connect(
    mapStateToProps, // pull initial values from account reducer
    actions // bind account loading action creator
)(SetPricingModal);

export default SetPricingModal;